import { Component, HostListener, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-fleet-card-loader',
  templateUrl: './fleet-card-loader.component.html',
  styleUrls: ['./fleet-card-loader.component.scss'],
})
export class FleetCardLoaderComponent implements OnInit {
  @Input() loader: (() => Promise<void>) | null = null;
  constructor() {}

  ngOnInit(): void {
    this.load();
  }

  loading = false;

  async load() {
    if (!this.loader) {
      return;
    }
    this.loading = true;
    await this.loader();
    this.loading = false;
  }
}
